<template>
	<div class="productsBox">
		<div class="productsCon">
			<indexTitle :title="dataInfo.moduleTitle" @goMore="goMore"></indexTitle>
			<div class="listBox">
				<div @click="$openUrl(item.jump_url, false)" v-for="item in dataInfo.list" :key="item.id"
					class="listItem">
					<div class="title">{{ item.title }}</div>
					<img class="centerImag" :src="item.cover" alt="" />
					<div class="footText">{{ item.desc }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import indexTitle from "./indexTitle.vue"
export default {
	components: {
		indexTitle,
	},
	props: {
		dataInfo: {
			type: Object,
			default: () => {
				return {
					is_show: 0,
					list: [],
					moduleTitle: '',
				}
			},
		},
	},
	data() {
		return {

		}
	},
	mounted() {

	},
	methods: {
		goMore() {
			let lang = this.$i18n.locale == 'zh' ? 'cn' : 'en'
			this.$router.push({
				path: `/${lang}/product`
			})
		},
	}
}
</script>

<style scoped lang="scss">
.productsBox {
	margin-top: 116px;
	background: #fff;

	.productsCon {
		width: 1200px;
		margin: auto;

		.listBox {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.listItem {
				width: 380px;
				background: #F7F7F7;
				padding: 50px 0 36px 0;
				margin-bottom: 20px;
				cursor: pointer;

				&:nth-last-child(1) {
					margin-bottom: 0px;
				}

				&:nth-last-child(2) {
					margin-bottom: 0px;
				}

				&:nth-last-child(3) {
					margin-bottom: 0px;
				}

				.title {
					text-align: center;
					font-size: 32px;
					color: #000000;
					padding-bottom: 23px;
				}

				.centerImag {
					width: 100%;
					height: 400px;
					object-fit: cover;
				}

				.footText {
					width: 100%;
					box-sizing: border-box;
					font-size: 18px;
					font-weight: 300;
					color: #010000;
					line-height: 24px;
					height: 96px;
					padding: 0 32px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 4;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}
		}
	}
}

@media screen and (max-width:1200px) {

	.productsBox {
		background: #fff;
		padding-bottom: 50px;

		.productsCon {
			width: 100%;
			margin: auto;

			.listBox {
				width: 100%;
				display: flex;
				flex-direction: column;
				align-items: stretch;

				.listItem {
					width: 100%;
					box-sizing: border-box;
					background: #F7F7F7;
					padding: 10px 0 24px 0;
					margin-bottom: 10px;
					margin-right: 0;

					.title {
						font-size: 22px;
						padding: 0 15px 16px;
					}

					.centerImag {
						height: 56vw;
					}

					.footText {
						font-size: 14px;
						line-height: 20px;
						height: auto;
						min-height: 60px;
						padding: 16px 15px 0;
						-webkit-line-clamp: 3;
					}
				}
			}
		}
	}

}
</style>
